import { get_token} from "@/router";
import { client_domain } from "@/main.js";
import Swal from "sweetalert2";

export default {

  data() {
    return ({
      token_exists: false,
      cbo_domain: false,
      dwypd_domain: false,
      soulcity_domain: false,
      user_details: null,
      upcoming_birthdays : [],
      visibleCount: 2,
      showAll: false,
    });
  },
  inject: ['client_features'],
  mounted() {
    this.token_exists = get_token();
    this.get_upcoming_birthdays();

    if (client_domain.includes('soulcity')  || client_domain.includes('nsp') || client_domain.includes('dwypd') || client_domain.includes('aicreads') || client_domain.includes('chiefluthuli')) {
      this.soulcity_domain = true;
    }
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return 'Date not set';
      const options = { day: 'numeric',month: 'long' };
      return new Date(dateStr).toLocaleDateString(undefined, options);
    },

    get_profile_name(profile) {
      const first_name = profile?.base_profile?.creater?.first_name || '';
      const last_name = profile?.base_profile?.creater?.last_name || '';
      return `${first_name} ${last_name}`.trim() || 'Profile';
    },

    get_profile_picture(profile) {
      return (
        profile?.base_profile?.creater?.profile_picture || null
      );
    },

    toggleShowMore() {
      // this.showAll = !this.showAll;
      window.location.href = `/view_all_birthdays`;
    },

    getToken() {
        return get_token();
    },
    get_upcoming_birthdays() {
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_upcoming_birthdays/`,
    method: "GET",
    headers: { Authorization: `Token ${this.getToken()}` },
    success: (response) => {
      // Filter out invalid dates
      let validBirthdays = response.data.filter(b => b.date_of_birth);

      // Sort by day ascending (assuming all birthdays are in current month)
      validBirthdays.sort((a, b) => {
        const dayA = new Date(a.date_of_birth).getDate();
        const dayB = new Date(b.date_of_birth).getDate();
        return dayA - dayB;
      });

      this.upcoming_birthdays = validBirthdays;
    },
  });
}

  }
}
